/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getInvoicePaymentOptions } from "@eisinc/App/Services/InvoicePaymentService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<ApiParameter, any>;

export const DispatchBeginLoadInvoices: HandlerType = (props: any) => {
    props.dispatch({
        type: "InvoicePayment/BeginLoadPaymentOptions",
        isLoading: true,
    });
};

export const XngGetInvoicePaymentApi: HandlerType = async props => {
    props.apiResult = await getInvoicePaymentOptions();
};

export const DispatchCompletedLoadInvoices: HandlerType = (props: any) => {
    const documents = props.apiResult?.documents;

    props.dispatch({
        type: "InvoicePayment/CompletedLoadPaymentOptions",
        isLoading: false,
        documents,
    });
};

export const chain = [DispatchBeginLoadInvoices, XngGetInvoicePaymentApi, DispatchCompletedLoadInvoices];

const loadInvoicePaymentOptions = createHandlerChainRunner(chain, "LoadInvoicePaymentOptions");
export default loadInvoicePaymentOptions;
